import { useInfiniteQuery } from '@tanstack/react-query'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'
import {
  GetReleaseArchiveParams,
  MaterialArchivePage
} from './getArchive.types'

export const RELEASE_ARCHIVE_QUERY_KEY = 'RELEASE_ARCHIVE'

export const getReleaseArchive = async ({
  search,
  cursor,
  limit
}: GetReleaseArchiveParams = {}) => {
  const response = await productUpdatesApi.get<
    SuccessResponse<MaterialArchivePage>
  >('/me/archive', {
    params: {
      search: search || undefined,
      cursor: cursor || undefined,
      limit
    }
  })
  return response?.data?.data
}

export const useReleaseArchiveInfiniteQuery = (
  search: string,
  enabled = true
) =>
  useInfiniteQuery({
    queryKey: [RELEASE_ARCHIVE_QUERY_KEY, search],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      getReleaseArchive({ search, cursor: pageParam }),
    getNextPageParam: lastPage => lastPage?.next_cursor ?? undefined,
    enabled,
    staleTime: 0
  })
